import { Capacitor } from '@capacitor/core';

// Topbar-Hintergrund je Modus — für die Android-Status-Bar.
const STATUS_BAR_BG = { dark: '#0f1923', light: '#ffffff' };

// Status-Bar an den aktiven Hell/Dunkel-Modus anpassen. No-Op im Browser.
// Style.Dark = heller Vordergrund (für dunklen Hintergrund),
// Style.Light = dunkler Vordergrund (für hellen Hintergrund).
export async function applyStatusBarForMode(mode) {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: mode === 'light' ? Style.Light : Style.Dark });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: STATUS_BAR_BG[mode] || STATUS_BAR_BG.dark });
    }
  } catch {
    /* Plugin optional */
  }
}

// Native-Initialisierung (Capacitor). Auf Web ein No-Op – die dynamischen Imports
// werden nur auf einem nativen Gerät (iOS/Android) ausgeführt. Bewusst schlank
// gehalten: Status Bar, Splash Screen ausblenden, Android-Zurück-Button.
export async function initNative() {
  if (!Capacitor.isNativePlatform()) return;

  // Status-Bar passend zum aktuell gewählten Theme-Modus.
  try {
    const { resolveMode } = await import('./theme');
    await applyStatusBarForMode(resolveMode());
  } catch {
    /* Theme-Modul optional */
  }

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide();
  } catch {
    /* Plugin optional */
  }

  try {
    const { App } = await import('@capacitor/app');
    // Android-Hardware-Zurück: in der App navigieren, an der Wurzel App beenden
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  } catch {
    /* Plugin optional */
  }
}
